import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { Icon } from "../generic/icon/Icon";
import { TextLoca } from "../generic/text/TextLoca";
export var ButtonSettingsPrimary = React.memo(function (_a) {
    var onClick = _a.onClick, icon = _a.icon, loca = _a.loca;
    return (React.createElement(ButtonPrimary, { onClick: onClick },
        React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
        React.createElement(FontWithOutline, { style: IdStyles.TextButtonDefault },
            React.createElement(TextLoca, { id: loca }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/settings/ButtonSettingsPrimary.tsx
// module id = 2754
// module chunks = 3